import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getZatcaDetailsReport = catchAsync(
  async ({
    currentLang,
    companyName = '',
    from_date_filter,
    to_date_filter,
    integration_status_filter = '',
  }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_custom_report?name=Zatca Integration Details&filters={"from_date_filter":"${from_date_filter}","to_date_filter":"${to_date_filter}","company_filter":"${companyName}","integration_status_filter":"${integration_status_filter}"}`
    );
    return data;
  }
);
export const getZatcaSummaryReport = catchAsync(
  async ({
    currentLang,
    companyName = '',
    from_date_filter,
    to_date_filter,
  }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_custom_report?name=Zatca Integration Summary&filters={"from_date_filter":"${from_date_filter}","to_date_filter":"${to_date_filter}","company_filter":"${companyName}"}`
    );
    return data;
  }
);
